import { AlertTriangle, FlaskConical } from 'lucide-react';
import { Badge } from '../ui/badge';
import { STATE_TONE } from '../../lib/atoAPI';

export const MockBanner = ({ text }) => (
  <div role="status" data-testid="ato-mock-banner"
    className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm font-medium text-amber-900">
    <AlertTriangle className="h-4 w-4 shrink-0" />
    {text || 'MOCK MODE – synthetic test data. Not connected to the ATO.'}
  </div>
);

export const SyntheticTag = ({ show }) => (show ? (
  <Badge variant="outline" className="border-amber-300 bg-amber-50 text-amber-900 text-[10px] gap-1" data-testid="synthetic-tag">
    <FlaskConical className="h-3 w-3" />SYNTHETIC
  </Badge>
) : null);

export const StateBadge = ({ state }) => (
  <Badge variant="outline" className={STATE_TONE[state] || 'bg-secondary'} data-testid={`state-${state}`}>{state?.replaceAll('_', ' ')}</Badge>
);

export const Empty = ({ children, testId }) => (
  <div className="rounded-md border border-dashed py-10 text-center text-sm text-muted-foreground" data-testid={testId}>{children}</div>
);

export const SimpleTable = ({ cols, rows, testId, empty = 'Nothing here yet.' }) => (rows.length === 0 ? <Empty testId={`${testId}-empty`}>{empty}</Empty> : (
  <div className="overflow-x-auto rounded-md border" data-testid={testId}>
    <table className="w-full text-sm">
      <thead className="bg-muted/50 text-left text-xs uppercase tracking-wide text-muted-foreground">
        <tr>{cols.map((c) => <th key={c.k} className="px-3 py-2 font-medium">{c.label}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.id || i} className="border-t hover:bg-muted/30 transition-colors" data-testid={`${testId}-row-${i}`}>
            {cols.map((c) => <td key={c.k} className="px-3 py-2 align-top">{c.render ? c.render(r) : r[c.k] ?? '—'}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
));
